import { combineReducers } from 'redux';
import { reducer as populationReducer } from './populationReducer';

const reducer = combineReducers({
  population: populationReducer,
});

export { reducer };
